import routes from '@/routes';
import {
  IconReport,
  IconUsersGroup,
  IconHome2,
  IconSettings,
  IconUsers,
  IconPercentage,
  IconTablePlus,
  IconCurrencyShekel,
  IconFileText,
  IconAlertCircle,
} from '@tabler/icons-react';

const links = [
  { icon: IconHome2, label: routes.main.name, to: routes.main.path },
  { icon: IconTablePlus, label: routes.imports.name, to: routes.imports.path },
  { icon: IconPercentage, label: routes.agencyCommissions.name, to: routes.agencyCommissions.path },
  { icon: IconUsersGroup, label: routes.agents.name, to: routes.agents.path },
  { icon: IconReport, label: routes.reports.name, to: routes.reports.path },
  { icon: IconCurrencyShekel, label: routes.monthlyPayment.name, to: routes.monthlyPayment.path },
  { icon: IconUsers, label: routes.users.name, to: routes.users.path },
  { icon: IconFileText, label: routes.paymentConfirm.name, to: routes.paymentConfirm.path },
  { icon: IconAlertCircle, label: routes.events.name, to: routes.events.path },
  { icon: IconSettings, label: routes.settings.name, to: routes.settings.path },
];

export {
  links,
};
